module.exports = __webpack_public_path__ + "static/assets/a690f35920e0f35f23c0c2d702fd7755.svg";